module.exports = __webpack_public_path__ + "img/苦杏仁.7053cb37.jpg";